import { useEffect, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { fetchLimitUsage } from 'pricing-pages-lib/api/fetchLimitUsage';
import { filterLimitsByMC0655Eligibility, sortLimitsByHigherUsage } from 'pricing-pages-lib/utils/usageLimitUtils';
import { fetchFeatureInterest } from 'pricing-pages-lib/api/featureInterestApi';
import { withErrorBoundary } from '../ErrorBoundary';
import { MC0655_LIMIT_USAGE_SECTION } from '../../constants/ErrorBoundaryNames';
import TeamMemberFeatureInterest from '../feature-interest/TeamMemberFeatureInterest';
import LimitCard from './LimitCard.tsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Mc0655LimitUsageSection = () => {
  const [fetchedData, setFetchedData] = useState({
    isFetching: true,
    limitUsages: [],
    featureInterest: []
  });
  useEffect(() => {
    Promise.all([fetchLimitUsage(), fetchFeatureInterest(STARTER)]).then(([limitUsageResponse, featureInterestResponse]) => {
      setFetchedData({
        isFetching: false,
        limitUsages: sortLimitsByHigherUsage(filterLimitsByMC0655Eligibility(limitUsageResponse)),
        featureInterest: featureInterestResponse
      });
    }).catch(() => {
      setFetchedData({
        isFetching: false,
        limitUsages: [],
        featureInterest: []
      });
    });
  }, []);
  if (fetchedData.isFetching) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 200
    });
  }
  return /*#__PURE__*/_jsxs("section", {
    style: {
      width: '100%'
    },
    className: "m-y-6",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "LIMIT_USAGE_FEATURE_INTEREST_SECTION"
    }), /*#__PURE__*/_jsx("div", {
      className: "p-x-1",
      children: /*#__PURE__*/_jsx(TeamMemberFeatureInterest, {
        featureInterest: fetchedData.featureInterest,
        isMC0655: true,
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(UIExpandableText
    //height to allow 3 stacked cards
    , {
      maxHeight: 870,
      expandButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ebxInterstitialPage.mc0655LimitUsageSection.expandCards`
      }),
      collapseButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ebxInterstitialPage.mc0655LimitUsageSection.collapseCards`
      }),
      onExpandButtonClick: () => getUsageTracker().track('upgradesInteraction', {
        action: 'clicked to expand limit cards section'
      }),
      onCollapseButtonClick: () => getUsageTracker().track('upgradesInteraction', {
        action: 'clicked to collapse limit cards section'
      }),
      children: /*#__PURE__*/_jsx(UICardGrid, {
        gutterSize: 16,
        columns: 2,
        expandToFill: true
        //small padding so the grid dropshadow is not hidden by the expandable container
        ,
        className: "p-all-1",
        style: {
          width: '100%'
        },
        children: fetchedData.limitUsages.map(limit => {
          return /*#__PURE__*/_jsx(LimitCard, {
            limit: limit
          }, limit.limitId);
        })
      })
    })]
  });
};
export default withErrorBoundary(Mc0655LimitUsageSection, {
  boundaryName: MC0655_LIMIT_USAGE_SECTION
});